module.exports = __webpack_public_path__ + "static/img/sun_qr_detail.ce16eff1.png";